import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import AbpBase from '@/lib/AbpBase';
var CreateUser = /** @class */ (function (_super) {
    __extends(CreateUser, _super);
    function CreateUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validatePassCheck = function (rule, value, callback) {
            if (!value) {
                callback(new Error(_this.L('ConfirmPasswordMsg')));
            }
            else if (value !== _this.user.password) {
                callback(new Error(_this.L('ConfirmPasswordNotMatch')));
            }
            else {
                callback();
            }
        };
        _this.userRule = {
            userName: [{
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('UserName')),
                    trigger: 'blur'
                }],
            name: [{ required: true, message: _this.L('FieldIsRequired', undefined, _this.L('Name')), trigger: 'blur' }],
            surname: [{
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('Surname')),
                    trigger: 'blur'
                }],
            phoneNumber: [{
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('PhoneNumber')),
                    trigger: 'blur'
                }
                // { type: 'tel' }
            ],
            emailAddress: [{
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('Email')),
                    trigger: 'blur'
                },
                { type: 'email' }
            ],
            password: [{
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('Password')),
                    trigger: 'blur'
                }],
            confirmPassword: { validator: _this.validatePassCheck, trigger: 'blur' }
        };
        return _this;
    }
    Object.defineProperty(CreateUser.prototype, "user", {
        get: function () {
            return this.$store.state.user.editUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateUser.prototype, "roles", {
        get: function () {
            return this.$store.state.user.roles;
        },
        enumerable: true,
        configurable: true
    });
    CreateUser.prototype.save = function () {
        var _this = this;
        this.$refs.userForm.validate(function (valid) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!valid) return [3 /*break*/, 2];
                        abp.ui.setBusy();
                        return [4 /*yield*/, this.$store.dispatch({
                                type: 'user/create',
                                data: this.user
                            }).finally(function () {
                                abp.ui.clearBusy();
                            })];
                    case 1:
                        _a.sent();
                        this.$refs.userForm.resetFields();
                        this.$emit('save-success');
                        this.$emit('input', false);
                        abp.ui.clearBusy();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    CreateUser.prototype.cancel = function () {
        this.$refs.userForm.resetFields();
        this.$emit('input', false);
    };
    CreateUser.prototype.visibleChange = function (value) {
        if (!value) {
            this.$emit('input', value);
        }
    };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], CreateUser.prototype, "value", void 0);
    CreateUser = __decorate([
        Component
    ], CreateUser);
    return CreateUser;
}(AbpBase));
export default CreateUser;
